import React from "react";
import style from "./index.module.scss";

interface FooterProps {
    children: React.ReactNode;
}

export default function Footer({ children }: FooterProps) {
    return <div className={style.root}>{children}</div>;
}
